import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { selectIsNavReady } from 'store/features/selectors';

import { PATHS } from 'constants/routerPaths';

import { canAccess } from './canAccess';
import { findNavItemByPathname } from './config';
import { useNavAccess } from './useNavAccess';

/**
 * Redirect off the current page if it became inaccessible mid-session
 * (e.g. a feature toggled off while the user is on it). Closes the loop the
 * route guards open only at navigation time.
 */
export const useEnforceAccess = (): void => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const navAccess = useNavAccess();
    const isNavReady = useSelector(selectIsNavReady);

    useEffect(() => {
        if (!isNavReady) {
            return;
        }

        const item = findNavItemByPathname(pathname);

        if (item && !canAccess(item.access, navAccess)) {
            navigate(PATHS.MAIN);
        }
    }, [pathname, navAccess, navigate, isNavReady]);
};
